import { render, staticRenderFns } from "./ExternalOrganizationCreate.vue?vue&type=template&id=2154e5d1&"
import script from "./ExternalOrganizationCreate.vue?vue&type=script&lang=js&"
export * from "./ExternalOrganizationCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports